'use client';

import {
  GETAPP_MODAL_BRAND_CONFIG as GETAPP_MODAL_BRAND_CONFIG_INTERNAL,
  createBrandedModalForm,
} from '../../react/brandConfig';

export type { ModalFormProps } from '../../react/ModalForm';
export type {
  ButtonPlacement,
  EmailStepRenderProps,
  QualificationStepConfig,
  QualificationStepRenderProps,
} from '../../react/ModalForm';

export const GETAPP_MODAL_BRAND_CONFIG = GETAPP_MODAL_BRAND_CONFIG_INTERNAL;

export const ModalForm = createBrandedModalForm(
  GETAPP_MODAL_BRAND_CONFIG,
  'GetAppModalForm'
);
